import { BookingLegVehicleRegistrationAndCargo } from "models/Booking";

export function createEmptyRegistrationAndCargoSlot(): BookingLegVehicleRegistrationAndCargo {
	return {
		commodityID: null,
		systemName: "",
		registrationPlate: "",
		contractCommodity: false
	};
}

export function getTrailerCount(numberOfRegistrationPlates?: number | null): number {
	return Math.max(0, (numberOfRegistrationPlates ?? 0) - 1);
}

export function getCargoSlotOffset(
	numberOfRegistrationPlates?: number | null,
	commodityUnits?: number | null
): number {
	return Math.max(0, (numberOfRegistrationPlates ?? 0) - (commodityUnits ?? 0));
}

export function getCargoSlotLabel(slotPosition: number): string {
	return slotPosition === 0 ? "Truck" : `Trailer ${slotPosition}`;
}

export function getTrailerAlignedSlots(
	registrationAndCargo: BookingLegVehicleRegistrationAndCargo[],
	numberOfRegistrationPlates?: number | null
): BookingLegVehicleRegistrationAndCargo[] {
	const trailerCount = getTrailerCount(numberOfRegistrationPlates);
	const relevantEntries = registrationAndCargo.slice(
		Math.max(0, registrationAndCargo.length - trailerCount)
	);
	const leadingEmptySlotCount = Math.max(0, trailerCount - relevantEntries.length);

	return [
		...Array.from({ length: leadingEmptySlotCount }, () => createEmptyRegistrationAndCargoSlot()),
		...relevantEntries
	];
}

export function getCargoBearingSlots(
	registrationAndCargo: BookingLegVehicleRegistrationAndCargo[],
	commodityUnits?: number | null
): Array<{ arrayIndex: number; slot: BookingLegVehicleRegistrationAndCargo }> {
	const cargoSlotCount = Math.max(0, commodityUnits ?? 0);
	const cargoArrayOffset = Math.max(0, registrationAndCargo.length - cargoSlotCount);

	return Array.from({ length: cargoSlotCount }, (_, index) => {
		const arrayIndex = cargoArrayOffset + index;

		return {
			arrayIndex,
			slot: registrationAndCargo[arrayIndex] ?? createEmptyRegistrationAndCargoSlot()
		};
	});
}
